(()=>{
  const pageSelector='[data-product-page]';

  document.addEventListener('click',(event)=>{
    const page=event.target.closest(pageSelector);
    if(!page)return;

    const open=event.target.closest('[data-pickup-modal-open]');
    if(open){
      const fulfillment=open.closest('[data-product-fulfillment]');
      const dialog=fulfillment?.querySelector('[data-pickup-dialog]');
      if(dialog&&typeof dialog.showModal==='function'&&!dialog.open)dialog.showModal();
      return;
    }

    const close=event.target.closest('[data-pickup-modal-close]');
    if(close){
      close.closest('[data-pickup-dialog]')?.close?.();
      return;
    }

    const dialog=event.target.closest('[data-pickup-dialog]');
    if(dialog&&event.target===dialog)dialog.close?.();
  });
})();
